import React from 'react'

export function Code() {
  return (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="1419"
      width="20"
      height="20"
      fill="currentColor"
    >
      <path
        d="M938.666667 503.893333v16.213334a32.853333 32.853333 0 0 1-9.386667 22.613333l-176.64 176.213333a21.333333 21.333333 0 0 1-30.293333 0l-30.293334-30.293333a20.906667 20.906667 0 0 1 0-29.866667L839.253333 512l-147.2-146.773333a21.333333 21.333333 0 0 1 0-30.293334l30.293334-29.866666a21.333333 21.333333 0 0 1 30.293333 0l176.64 176.213333a32 32 0 0 1 9.386667 22.613333zM184.746667 512l146.773333-146.773333a20.906667 20.906667 0 0 0 0-29.866667l-30.293333-30.293333a21.333333 21.333333 0 0 0-30.293334 0l-176.213333 176.213333a32.853333 32.853333 0 0 0-9.386667 22.613333v16.213334a32 32 0 0 0 9.386667 22.613333l176.64 176.213333a21.333333 21.333333 0 0 0 30.293333 0l30.293334-29.866666a21.333333 21.333333 0 0 0 0-30.293334z m469.333333-325.546667L612.693333 170.666667a22.186667 22.186667 0 0 0-27.733333 12.8L358.4 810.666667a21.333333 21.333333 0 0 0 12.8 27.306666l40.106667 14.506667a21.76 21.76 0 0 0 27.306666-12.8L665.173333 213.333333a21.333333 21.333333 0 0 0-12.8-26.88z"
        p-id="1420"
      ></path>
    </svg>
  )
}
